import React, { useState, useEffect } from "react";
import { useVocabData } from "../hooks/useVocabData";
import { useSentenceInstructionAudio } from "../hooks/useInstructionAudio";
import { useAnalyzeTranslation } from "../hooks/useAnalyzeTranslation";
import { useVocabNavigation } from "../hooks/useVocabNavigation";
import { useSpeechRecognition } from "../hooks/useSpeechRecognition";
import { VOCAB_CONSTANTS } from "../constants/vocabConstants";
import { audioService } from "../services/audioService";
import MainContainer from "../components/Containers/MainContainer";
import ContentContainer from "../components/Containers/ContentContainer";
import HelpNotice from "../components/Notices/HelpNotice";
import ChapterNavigation from "../components/Navigation/ChapterNavigation";
import WordDisplayCard from "../components/Cards/WordDisplayCard";
import PracticeSection from "../components/Practice/PracticeSection";
import { getAnalysisColorClasses } from "../utils/analysisUtils";

const SentenceLearn2 = () => {
  const [pageIndex, setPageIndex] = useState(0);
  const { data, isLoading, isError, error } = useVocabData(pageIndex);
  const { words, wordsNative, sentences, sentencesNative } = data || {};

  const { currentIndex, handleNext, handlePrev, resetIndex } =
    useVocabNavigation(words?.length);

  const curr = pageIndex * VOCAB_CONSTANTS.WORDS_PER_CHAPTER + currentIndex;

  const {
    data: audioUrl,
    isLoading: isAudioLoading,
    isError: isAudioError,
    error: audioError,
  } = useSentenceInstructionAudio(curr);

  const { isListening, startListening } = useSpeechRecognition();
  const [dialogState, setDialogState] = useState(
    VOCAB_CONSTANTS.DEFAULT_DIALOG_STATE
  );
  const [userResponse, setUserResponse] = useState("");

  const {
    data: analysisData,
    isLoading: isAnalysisLoading,
    isError: isAnalysisError,
    error: analysisError,
    refetch: analyzeTranslation,
  } = useAnalyzeTranslation(
    sentences ? sentences[currentIndex] : "",
    userResponse
  );

  const { analysisReport, analysisAudioLink } = analysisData || {};

  // console.log("Analysis Report:", analysisReport);
  // console.log("Analysis Audio Link:", analysisAudioLink);

  const handleNavigation = (direction) => {
    if (direction === "next") {
      handleNext();
    } else {
      handlePrev();
    }
    setUserResponse("");
  };

  const handleListenToInstruction = () => {
    audioService.playAudio(audioUrl);
  };

  const handleStartListening = () => {
    startListening(
      (transcript) => setUserResponse(transcript),
      (state) => setDialogState(state)
    );
  };

  const handleAnalyzeTranslation = () => {
    // setDialogState("পর্যবেক্ষণ করছি");
    analyzeTranslation();
    // setDialogState(VOCAB_CONSTANTS.DEFAULT_DIALOG_STATE);
  };

  useEffect(() => {
    if (isAnalysisLoading) {
      setDialogState("পর্যবেক্ষণ করছি");
    } else {
      setDialogState(VOCAB_CONSTANTS.DEFAULT_DIALOG_STATE);
    }
  }, [isAnalysisLoading]);

  const playFeedbackAudio = () => {
    audioService.playAudio(analysisAudioLink);
  };

  const handlePageChange = (pageIndex) => {
    setPageIndex(pageIndex);
    resetIndex();
    setUserResponse("");
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex items-center justify-center">
        <div className="text-lg text-gray-600">Loading...</div>
      </div>
    );
  }

  return (
    <MainContainer>
      <ContentContainer>
        <HelpNotice />

        <ChapterNavigation
          currentPage={pageIndex}
          onPageChange={handlePageChange}
          length={VOCAB_CONSTANTS.TOTAL_CHAPTERS}
          loading={isLoading}
        />

        <div className="grid grid-cols-1 gap-8">
          <WordDisplayCard
            text={sentences[currentIndex]}
            subText="ইংরেজি বাক্য"
            textNative={sentencesNative[currentIndex]}
            currentIndex={currentIndex}
            totalWords={sentences.length}
            onNext={() => handleNavigation("next")}
            onPrev={() => handleNavigation("prev")}
            onListen={handleListenToInstruction}
          />

          <PracticeSection
            dialogState={dialogState}
            isListening={isListening}
            userResponse={userResponse}
            analysisReport={
              analysisReport
                ? analysisReport.split("ফিডব্যাক:").pop().trim()
                : null
            }
            onStartListening={handleStartListening}
            onAnalyze={handleAnalyzeTranslation}
            colorClass={getAnalysisColorClasses(isAnalysisError ? "error": "success")}
          />
        </div>
      </ContentContainer>
    </MainContainer>
  );
};

export default SentenceLearn2;
